import React from 'react';
import NavDashboardGridIcon from '../icons/NavDashboardGridIcon';
import NavApplicationsIcon from '../icons/NavApplicationsIcon';
import NavQuoteIcon from '../icons/NavQuoteIcon';
import NavSentApplicationsIcon from '../icons/NavSentApplicationsIcon';
import NavMoreOptionsIcon from '../icons/NavMoreOptionsIcon';
import { getColors } from '../../Themes/default_color';
import { getContrastText } from '../../utils/commonUtilities';
const getStrokeColor = (isActive) => (isActive ? getContrastText(getColors().Primary) : '#6E6E77');
export function DashboardNavIcon({ isActive }) {
    const stroke = getStrokeColor(isActive);
    return (React.createElement("div", { className: 'revamp-tab-icon-wrap' },
        React.createElement(NavDashboardGridIcon, { stroke: stroke })));
}
export function ApplicationsNavIcon({ isActive }) {
    const stroke = getStrokeColor(isActive);
    return (React.createElement("div", { className: 'revamp-tab-icon-wrap' },
        React.createElement(NavApplicationsIcon, { stroke: stroke })));
}
export function QuoteToolNavIcon({ isActive }) {
    const stroke = getStrokeColor(isActive);
    return (React.createElement("div", { className: 'revamp-tab-icon-wrap' },
        React.createElement(NavQuoteIcon, { stroke: stroke })));
}
export function SentApplicationsNavIcon({ isActive }) {
    const stroke = getStrokeColor(isActive);
    return (React.createElement("div", { className: 'revamp-tab-icon-wrap' },
        React.createElement(NavSentApplicationsIcon, { stroke: stroke })));
}
export function MoreNavIcon({ isActive }) {
    const stroke = getStrokeColor(isActive);
    return (React.createElement("div", { className: 'revamp-tab-icon-wrap' },
        React.createElement(NavMoreOptionsIcon, { stroke: stroke })));
}
